module.exports = __webpack_public_path__ + "img/icon2.69b22397.png";